import { emailApi } from './api/emailApi';
import { withRetry } from './utils/emailRetry';
import type { ContactFormData } from '../../types/contact';
import type { TrainingFormData } from '../../types/training';

export class EmailService {
  static async sendContactForm(data: ContactFormData) {
    console.log('Sending contact form:', data);
    return withRetry(() => emailApi.sendContactForm(data));
  }

  static async sendTrainingRequest(data: TrainingFormData) {
    console.log('Sending training request:', data);
    return withRetry(() => emailApi.sendTrainingRequest(data));
  }
}